module.exports = __webpack_public_path__ + "img/133.72b5f29a.jpg";